import { render, staticRenderFns } from "./QColorPicker.vue?vue&type=template&id=2437ba6a&scoped=true"
import script from "./QColorPicker.vue?vue&type=script&lang=js"
export * from "./QColorPicker.vue?vue&type=script&lang=js"
import style0 from "./QColorPicker.vue?vue&type=style&index=0&id=2437ba6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2437ba6a",
  null
  
)

export default component.exports